'use client';

import { buildImageSrc } from '@/app/[locale]/(home)/_components/CategoriesList/utils';
import { IShipper } from '@/_types';
import { AspectRatio, Box, Image, VStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { RefObject } from 'react';
import SectionsView from '../../components/SectionsView';
import { Section } from '../../utils';
import AlertWorkingHours from '@/_components/AlertWorkingHours';

type Props = {
  brand: IShipper;
  sections: Section[];
  sectionRefs: RefObject<Record<string, HTMLDivElement | null>>;
};

const WithCategories: React.FC<Props> = ({
  brand,
  sections,
  sectionRefs,
}) => {
  const t = useTranslations();
  const menuImg = buildImageSrc(
    typeof brand?.menu_image === 'string'
      ? brand.menu_image
      : brand.menu_image?.value,
  );
  return (
    <Box as='main' minW={0}>
      <VStack align='stretch' gap={6}>
        {/* Hero Image */}
        {brand.logo && (
          <AspectRatio ratio={4 / 2} rounded={24} overflow='hidden'>
            <Image
              src={menuImg}
              alt={brand.name || 'Brand logo'}
              w='full'
              h='full'
              objectFit='cover'
            />
          </AspectRatio>
        )}
        <AlertWorkingHours />
        <SectionsView
          sections={sections}
          sectionRefs={sectionRefs}
          emptyText={t('no_products')}
        />
      </VStack>
    </Box>
  );
};

export default WithCategories;
